<template>
  <div v-if="state.open" class="gd-overlay" @click.self="noop">
    <div class="gd-modal" role="dialog" aria-modal="true">
      <div class="gd-msg h5" v-html="state.messageHtml"></div>

      <div class="gd-actions">
        <div class="row">
          <div class="col text-center" v-if="state.type === 'confirm'">
            <button  @click="cancel" class="btn btn-light btn-outline-secondary">
              {{ state.cancelText }}
            </button>
          </div>
          <div class="col text-center">
            <button @click="ok" class="btn btn-primary">
              {{ state.okText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { state, resolveOk, resolveCancel } from '../services/dialogService'
const ok = () => resolveOk()
const cancel = () => resolveCancel()
const noop = () => {}
</script>

<style scoped>
.gd-overlay{
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(0,0,0,.45);
  z-index: 2147483647;
}
.gd-modal{
  width: min(520px, 92vw);
  background: #fff;
  color: #111;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,.25);
}
.gd-msg{ line-height: 1.6; }
.gd-actions{
  /* display: flex; */
  justify-content: flex-end;
  gap: 8px;
  margin-top: 14px;
}
</style>
